import { render, staticRenderFns } from "./ClientIndemnity.vue?vue&type=template&id=78e6d7c4"
import script from "./ClientIndemnity.vue?vue&type=script&lang=js"
export * from "./ClientIndemnity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports